<div class="ibox detailed-view-ibox" *ngIf="true">
    <div class="detailed-view-header">
        <div class="detailed-view-title">
            {{corporation.name}}
        </div>
        <span class="close-detailed-view" (click)="close()">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form class="content" #form="ngForm" submittable autocomplete="off">
                <input-field name="corporationNumber"
                             title="Corporation"
                             [ngModel]="corporation.name"
                             (update)="updateCorporation({name: form.value.corporationNumber})">
                </input-field>

                <search-select-field name="companyId"
                                     title="Property Mgmt"
                                     [data]="companySelectOptions"
                                     (update)="updateCorporation({companyId: form.value.companyId})"
                                     [ngModel]="corporation.companyId">
                </search-select-field>

                <div class="buildings-list">
                    <div class="title"><strong>Buildings</strong></div>
                    <multiselect-field *ngIf="!isBuildingsLoading" name="buildings"
                                       [data]="buildingSelectOptions"
                                       [(ngModel)]="selectedBuildings"
                                       (update)="updateCorporationBuildings(form.value.buildings)">
                    </multiselect-field>
                    <spinner [spinnerShow]="isBuildingsLoading"></spinner>
                </div>

                <input-field name="logoutUrl"
                             title="Log Out Page"
                             [ngModel]="corporation.logoutUrl"
                             (update)="updateCorporation({logoutUrl: form.value.logoutUrl})">
                </input-field>
            </form>

            <div *ngIf="propertyService.account.isUserAdmin()"
                 class="btn-group dropup">
                <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                    Actions <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                    <li>
                        <a (click)="propertyService.remove(corporation.id)">Delete</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/corporation-detailed-view/corporation-detailed-view.component.html